import App from "../controllers/App/App";

const queries = () => [];

const mappingRunHistory = (path, navigation, exact, title) => ({
    path,
    navigation,
    component: App,
    exact,
    queries,
    title: [title],
    components: [],
});

export default mappingRunHistory;
